export default "__VITE_ASSET__bci9aQP3__"